import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { symbol as Symbol } from '@wix/santa-editor-symbols';

export default {
  Circle: () => <Symbol name="motion-shapes-circle" />,
  Ellipse: () => <Symbol name="motion-shapes-ellipse" />,
  Rhombus: () => <Symbol name="motion-shapes-rhombus" />,
  Rectangle: () => <Symbol name="motion-shapes-rectangle" />,
};
